import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { ZegoMediaControlService } from '../../../../services/zego-media-control.service';
import { ZegoStreamService } from '../../../../services/zego-stream.service';
import { AppIconComponent } from '../../../icon/icon.component';
import { SoundIconComponent } from '../../../sound-icon/sound-icon.component';
import { CallZegoService } from '../../services/call-zego.service';
import { CallParticipant } from '../../types/call';

@Component({
  selector: 'app-call-share-screen',
  standalone: true,
  imports: [AppIconComponent, SoundIconComponent],
  templateUrl: './call-share-screen.component.html',
  styleUrl: './call-share-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallShareScreenComponent implements AfterViewInit {
  private callZegoService = inject(CallZegoService);
  private zegoStreamService = inject(ZegoStreamService);
  private zegoMediaControlService = inject(ZegoMediaControlService);

  isScreenSharing = input.required<boolean>();
  isRemoteSharing = input.required<boolean>();
  isFullScreenShare = input.required<boolean>();
  participant = input<CallParticipant | null>(null);
  sharingMicOn = input.required<boolean>();
  sharingSoundLevel = input.required<number>();

  stopShare = output<void>();
  toggleFullScreen = output<void>();

  ngAfterViewInit(): void {
    const remoteId = this.participant()?.userId;
    if (remoteId) {
      const screenStream = this.callZegoService.remoteStreams()[`${remoteId}_screen`];
      if (screenStream) {
        this.zegoStreamService.playStreamToDOM(screenStream, 'remote-screen');
      }
    }

    if (this.zegoMediaControlService.screenStream) {
      let screenPreviewElement = document.getElementById('screen-preview') as HTMLDivElement;
      if (window.documentPictureInPicture?.window) {
        screenPreviewElement = window.documentPictureInPicture.window.document.getElementById(
          'screen-preview',
        ) as HTMLDivElement;
      }
      if (screenPreviewElement) {
        this.zegoMediaControlService.screenStream.playVideo(screenPreviewElement, {
          enableAutoplayDialog: false,
          objectFit: 'contain',
        });
      }
    }
  }
}
